import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes,faEye } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Popup from "reactjs-popup";
import "bootstrap/dist/css/bootstrap.css";
import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import apiUrl from "../../apiUrlConstant";
import TopHeader from "../../layout/TopHeader";
import { ChartPopup } from "../../utils/utils";
import { fileUploadPath } from "../../utils/index";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getToDate } from "../../utils/utils";
var ReactS3Uploader = require("react-s3-uploader");

var today = new Date(),
  date =
    today.getDate() + "/" + today.getMonth() + 1 + "/" + today.getFullYear();

class VoucherGcConfirmationComponent extends React.Component {
  state = {
    //terminationEffectiveDate: new Date(),
    //effectiveDate: new Date(),
    messageToShow: "",
    redirect: false,
    changeLandlord: false,
    delete: false,
    additionalDetails: [],
    leaseId: this.props.leaseId,
    voucherId: this.props.voucherId,
    leaseCode: this.props.leaseCode,
    costCenter:this.props.costCenter,
    fileName: "Activation-Doc.pdf",
    date: "",
    fileAdded: {},
    activationDate: this.props.gcStartDate,
    gcEndDate: this.props.gcEndDate,
    initialValues: {
      landlordId: [],
    },
  };
  style = (feature) => {
    return {
      fillColor: "#ccc",
      weight: 1,
      opacity: 1,
      color: "#003970",
      dashArray: "2",
      fillOpacity: 0.5,
    };
  };
  constructor(props) {
    super(props);
    
    //console.log(props, "props");
    //this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  componentDidMount() {
    var date = new Date();
    var formatedDate = `${
      date.getFullYear() + 1
    }-${date.getMonth()}-${date.getDate()}`;
    this.setState({ terminationEffectiveDate: formatedDate }, () => {
      console.log(this.state.terminationEffectiveDate);
    });
    console.log(this.props, "props checking")
    //this.state.activationDate = this.props.gcStartDate;
    //this.state.gcEndDate = this.props.gcEndDate;
    this.setState({});
    console.log(formatedDate);
  }


  hidePopup() {
    console.log(this.props, "thisparet");  
    this.props.setGcActivation(false);
  }

  handleTypeChange = (e) => {
    if (e.target.value !== "landlord_termination") {
      this.setState({
        changeLandlord: false,
        termination_type: e.target.value,
      });
    }
    this.setState({});
    console.log(this.state.termination_type, "termination_type");

    //this.setState({ fruit: e.target.value });
  };

  redirectAfterSave = () => {
    this.setState({ delete: false });
  };


  render() {
    return (
      <div>
        <Formik
          initialValues={
            {
              //"leaseRegistrationDate" : "26/05/2022"
              //effectiveDate: '02/02/2022'
            }
          }
          //enableReinitialize
          onSubmit={(values, actions) => {

            if(typeof this.state.activationDate == "undefined" || this.state.activationDate == ''  || this.state.activationDate == '0000-00-00') {
                this.setState({ messageToShow: "Please select activation date", delete: true });
                return false;
            }

            var self = this;
            axios({
            method: "post",
            url: `${apiUrl.apiUrl.url}/voucher/gc-activation?voucherId=${this.state.voucherId}`,
            data: { 'start': this.state.activationDate, 'end' : this.state.gcEndDate },
            }).then(function (response) {
            if (!response.data.success) {
                self.props.setpopupMessageContent("Something went wrong.");
                self.props.setpopupalertMessage(true);
            } else {
                //self.props.ths.state.counter = Math.random();
                self.props.setkeyCounter(Math.random());
                self.hidePopup();
                self.props.setpopupMessageContent("Details Stored successfully.");
                self.props.setpopupalertMessage(true);
                
                self.props.ths.setState({ counter : Math.random() });    
                //console.log(self.props.ths.state, "state heckng", Math.round())
                //self.props.ths.state({});
            }   
            });
            

          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
            resetForm,
          }) => (
            <Form autoComplete="off" className="customTabs">
              <div className="unitFormContainer amend">
                <div className="container-fluid p-0">
                  <div className="row prospectAccordion">
                    <div className="col-lg-6 offset-lg-3">
                      <div className="tableContainer prospectTable mt-0">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Lease No
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.state.leaseCode}
                              </td>                             
                            </tr>
                            <tr>
                            <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Cost Center
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.props.costCenter}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="inputContainer"></div>
                    </div>
                    <div className="col-lg-12">
                      <div className="tableContainer screens">
                       

                        <table className="table tableSimple">
                          <thead>
                            <tr>
                              <th>Section</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Activation Date</td>
                              <td>
                                <Field type="date" name="activationDate" value={this.state.activationDate} onChange={(e) => {               
                                        this.state.activationDate = e.target.value;
                                        if( this.props.uom == "years" ) {
                                            this.state.gcEndDate = getToDate(e.target.value, 0, 0, this.props.validityCount );
                                        }else if( this.props.uom == "months" ) {
                                            this.state.gcEndDate = getToDate(e.target.value, 0, this.props.validityCount, 0 );
                                        }else {
                                            this.state.gcEndDate = getToDate(e.target.value, this.props.validityCount, 0, 0 );
                                        }
                                        
                                        handleChange(e);
                                    }} />                              
                              </td>
                            </tr>
                            <tr>
                              <td>GC End Date</td>
                              <td>
                              <Field type="date" name="gcEndDate" value={this.state.gcEndDate} readOnly />                                
                              </td>
                            </tr>
                            
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {(
                      <div className="col-lg-12">
                        <button variant="secondary" type="submit">
                          {/* <FontAwesomeIcon icon={faTimes} />  */}Submit
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>

        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              {this.state.messageToShow}
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectAfterSave}>
                  Ok
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
    );
  }
}

export default withRouter(VoucherGcConfirmationComponent);
